import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["prefixCls", "getPopupContainer", "className", "bordered", "placeholder"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import classNames from 'classnames';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import RCPicker from 'rc-picker';
import devWarning from '../../../_utils/devWarning';
import { ConfigContext } from '../../../../config/context/config';
import { getTimeProps, Components } from '.';
import { getPlaceholder } from '../../util';
import { locale } from '../../const/locale';
import { ArrowLeftOne, ArrowRightOne, Calendar, CloseOne, DoubleLeft, DoubleRight } from '@tencent/adp-icons-react';
export default function generatePicker(generateConfig) {
  function getPicker(picker, displayName) {
    var Picker = /*#__PURE__*/function (_React$Component) {
      _inherits(Picker, _React$Component);
      var _super = _createSuper(Picker);
      function Picker(props) {
        var _this;
        _classCallCheck(this, Picker);
        _this = _super.call(this, props);
        _this.pickerRef = React.createRef();
        _this.focus = function () {
          if (_this.pickerRef.current) {
            _this.pickerRef.current.focus();
          }
        };
        _this.blur = function () {
          if (_this.pickerRef.current) {
            _this.pickerRef.current.blur();
          }
        };
        _this.renderPicker = function () {
          var getPrefixCls = _this.context.getPrefixCls;
          var _this$props = _this.props,
            customizePrefixCls = _this$props.prefixCls,
            customizeGetPopupContainer = _this$props.getPopupContainer,
            className = _this$props.className,
            _this$props$bordered = _this$props.bordered,
            bordered = _this$props$bordered === void 0 ? true : _this$props$bordered,
            placeholder = _this$props.placeholder,
            restProps = _objectWithoutProperties(_this$props, _excluded);
          var _this$props2 = _this.props,
            format = _this$props2.format,
            showTime = _this$props2.showTime;
          var prefixCls = getPrefixCls('picker', customizePrefixCls);
          var additionalProps = {
            showToday: false
          };
          var additionalOverrideProps = {};
          if (picker) {
            additionalOverrideProps.picker = picker;
          }
          var mergedPicker = picker || _this.props.picker;
          additionalOverrideProps = _objectSpread(_objectSpread(_objectSpread({}, additionalOverrideProps), showTime ? getTimeProps(_objectSpread({
            format: format,
            picker: mergedPicker
          }, showTime)) : {}), mergedPicker === 'time' ? getTimeProps(_objectSpread(_objectSpread({
            format: format
          }, _this.props), {}, {
            picker: mergedPicker
          })) : {});
          var rootPrefixCls = getPrefixCls();
          return React.createElement(RCPicker, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            ref: _this.pickerRef,
            placeholder: getPlaceholder(mergedPicker),
            suffixIcon: mergedPicker === 'time' ? React.createElement(ClockCircleOutlined, null) : React.createElement(Calendar, {
              fill: "#666",
              size: 16
            }),
            clearIcon: React.createElement(CloseOne, {
              size: 14
            }),
            prevIcon: React.createElement(ArrowLeftOne, {
              size: 14,
              className: "".concat(prefixCls, "-prev-icon")
            }),
            nextIcon: React.createElement(ArrowRightOne, {
              size: 14,
              className: "".concat(prefixCls, "-next-icon")
            }),
            superPrevIcon: React.createElement(DoubleLeft, {
              size: 14,
              className: "".concat(prefixCls, "-super-prev-icon")
            }),
            superNextIcon: React.createElement(DoubleRight, {
              size: 14,
              className: "".concat(prefixCls, "-super-next-icon")
            }),
            allowClear: true,
            transitionName: "".concat(rootPrefixCls, "-slide-up")
          }, additionalProps), restProps), additionalOverrideProps), {}, {
            className: classNames(_defineProperty({}, "".concat(prefixCls, "-borderless"), !bordered), className),
            prefixCls: prefixCls,
            getPopupContainer: customizeGetPopupContainer,
            generateConfig: generateConfig,
            components: Components,
            locale: locale.lang
          }));
        };
        devWarning(picker !== 'quarter', displayName, "DatePicker.".concat(displayName, " is legacy usage. Please use DatePicker[picker='").concat(picker, "'] directly."));
        return _this;
      }
      _createClass(Picker, [{
        key: "render",
        value: function render() {
          return this.renderPicker();
        }
      }]);
      return Picker;
    }(React.Component);
    Picker.contextType = ConfigContext;
    if (displayName) {
      Picker.displayName = displayName;
    }
    return Picker;
  }
  return {
    DatePicker: getPicker(),
    WeekPicker: getPicker('week', 'WeekPicker'),
    MonthPicker: getPicker('month', 'MonthPicker'),
    YearPicker: getPicker('year', 'YearPicker'),
    TimePicker: getPicker('time', 'TimePicker'),
    QuarterPicker: getPicker('quarter', 'QuarterPicker')
  };
}